module.exports = __webpack_public_path__ + "img/icn_scarpa_bianca.1c37111c.png";